import { useMemo } from 'react';

import {
  IEditForm,
  CasEditForm,
  CasRHFTextField,
  CasRHFSwitch,
} from 'src/compass/shared/components';
import { CasRHFSharepointSiteSelect } from 'src/compass/application';

import { AgenciesSchema } from './AgenciesSchema';

export default function AgenciesForm({ row, onSaved }: IEditForm) {
  const { id } = row || {};

  const defaultValues = useMemo(() => (id ? row : { isActive: true }), [id, row]);

  return (
    <CasEditForm
      defaultValues={defaultValues}
      onSaved={onSaved}
      entity="Sce/Claims/InsAgency"
      schema={AgenciesSchema}
    >
      <CasRHFTextField name="name" label="Name" />
      <CasRHFTextField name="agencyNbr" label="Agency#" />
      <CasRHFSharepointSiteSelect name="claimsSharepointSiteId" label="Sharepoint Site" />
      <CasRHFTextField name="claimsSharepointRoot" label="Sharepoint Root" />
      <CasRHFSwitch name="isActive" label="Active" />
    </CasEditForm>
  );
}
